import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const NewApplicationDropdown = () => {
	return (
		<details className="dropdown dropdown-end">
			<summary className="m-1 btn btn-primary">
				New Application
				<ChevronDownIcon aria-hidden="true" className="w-5 h-5 -mr-1" />
			</summary>
			<ul className="menu dropdown-content rounded-box z-[1] w-52 border border-gray-300 bg-white p-2 shadow">
				<li>
					<Link to="/newApplication">Zip Code Search</Link>
				</li>
				<li>
					<Link to="/newApplication/profile">Profile</Link>
				</li>
			</ul>
		</details>
	);
};

export default NewApplicationDropdown;
